import {InspectionOtherPage} from 'modules/InspectionOther';

export default InspectionOtherPage;
